import { Component, OnInit, OnDestroy, NgModule} from '@angular/core';
import { TranslateService } from '@ngx-translate/core'; 
import { Subject } from 'rxjs';
import { UserSessionService } from '../../app-user-session.service'; 
import { takeUntil } from 'rxjs/operators'; 
import { SharedModule } from '../../shared';
import { BlocksModule } from '../../blocks/blocks.module';
import {  AlertApprovCycleTransMod } from '../alert-approv-cycle-trans/alert-approve-cycle-trans.component';
import { AlertApprovCycleTransService } from '../alert-approv-cycle-trans/alert-approve-cycle-trans.service';
import { FastSearchModule } from '../../blocks/ui-component/fast-search/fast-search.module';


@Component({
  selector: 'hr-alert-approval-cycle-trans-emp',
  templateUrl: './hr-alert-approval-cycle-trans-emp.component.html',
})
export class HrAlertApprovalCycleTransEmpComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  showApprovalUsers : boolean;
  fromOtherComp : boolean;
  empId : number;
  requestTypeAsTest : string
  actionSerial : number;
  constructor(
    private _userSessionService: UserSessionService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    if (this._userSessionService.getSessionKey<any>('userLoginEmpId')) { 
      this._userSessionService.subscribeToKey$('userLoginEmpId').pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
          if (keys.value) {
            this.empId = keys.value;
          }
        });}

        if (this._userSessionService.getSessionKey<any>('AlertApprovalCycleTransEmpSession')) { 
          this._userSessionService.subscribeToKey$('AlertApprovalCycleTransEmpSession').pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
              if (keys.value) {
                this.requestTypeAsTest = keys.value.requestType
                this.actionSerial = keys.value.alertSerial
                this.fromOtherComp = true;
                this.getReqAlertApproval()
              }
            });}
    
  }



  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
 
  onSearchClick(ev){
    this.actionSerial = ev.ActionSerial
     if(ev.requestType ==1 ){this.requestTypeAsTest = 'VACATION_REQUEST'}
     if(ev.requestType ==2 ){this.requestTypeAsTest = 'PERMISSION_REQUEST'}
     if(ev.requestType ==13 ){this.requestTypeAsTest = 'LOAN_REQUEST'}
     if(ev.requestType ==14 ){this.requestTypeAsTest = 'NEED_REQUEST'}
     if(ev.requestType ==16 ){this.requestTypeAsTest = 'ORDER_SUPPLY'}
     if(ev.requestType ==17 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==18 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==19 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==20 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==21 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==21 ){this.requestTypeAsTest = 'PERMISSION_EXCHANGE'}
     if(ev.requestType ==25 ){this.requestTypeAsTest = 'EXAMINATION_ORDER'}
     if(ev.requestType ==26 ){this.requestTypeAsTest = 'AIRLINETICKET_REQUEST'}
     if(ev.requestType ==27 ){this.requestTypeAsTest = 'PUNISHMENT_REQUEST'}
     if(ev.requestType ==28 ){this.requestTypeAsTest = 'PROMOTION_REQUEST'}
      this.getReqAlertApproval()
  }


  getReqAlertApproval(){
    this._userSessionService.setSessionKey('FromEmployeePortal', true)
    this._userSessionService.setSessionKey('RequestAlertSerial', { alertSerial :this.actionSerial, requestType : this.requestTypeAsTest})
    this.showApprovalUsers = true
  }
  
   
}

@NgModule({
  imports: [SharedModule,BlocksModule,FastSearchModule,AlertApprovCycleTransMod],
  declarations: [HrAlertApprovalCycleTransEmpComponent],
  providers: [AlertApprovCycleTransService],
  exports: [HrAlertApprovalCycleTransEmpComponent]
})
export class AlertApprovCycleTransEmpMod { }
